module.exports = __webpack_public_path__ + "img/43_44.85ea218c.png";